import React, { useState } from 'react';
import ProcessManager from './ProcessManager';
import PipelineCleanupPage from './PipelineCleanupPage';
import '../styles/ManagePipeline.css';

const ManagePipeline = () => {
  const [activeTab, setActiveTab] = useState('processManager');

  return (
    <div className="pipeline-management-wrapper unique-tabs-page-container">
      <div className="pipeline-header">
        <h2>Pipeline Management</h2>
        <p>Monitor running pipelines and manage cleanup operations</p>
      </div>

      <div className="tabs-navigation">
        <button
          className={`tab-button ${activeTab === 'processManager' ? 'active' : ''}`}
          onClick={() => setActiveTab('processManager')}
        >
          📊 Running Pipelines
        </button>
        <button
          className={`tab-button ${activeTab === 'pipelineCleanup' ? 'active' : ''}`}
          onClick={() => setActiveTab('pipelineCleanup')}
        >
          🧹 Pipeline Cleanup
        </button>
      </div>

      <div className="tabs-content">
        {activeTab === 'processManager' && (
          <div className="tab-content">
            <ProcessManager />
          </div>
        )}

        {activeTab === 'pipelineCleanup' && (
          <div className="tab-content">
            <PipelineCleanupPage />
          </div>
        )}
      </div>
    </div>
  );
};

export default ManagePipeline;
